import { TravelRegistryFilter } from '@/module/Travel/Registry/model/TravelRegistryTypes';
import { TravelRequestSummary, TravelStepKey } from '@/module/Travel/Request/model/TravelRequestTypes';
import { TravelReturnMode } from '@/module/Travel/Settings/model/TravelSettingsTypes';

import { PagedParams, PagedResponse } from '@feature/utils';

// The queue accepts every registry filter; a null year means all years here, not the current one.
export interface TravelApprovalFilter extends TravelRegistryFilter {
  // false or null, never true: the server defaults to pending-only and the serializer skips nulls.
  pendingOnly: false | null;
  // Matched on the step that puts the request in the caller's queue; empty keeps every step.
  stepKeys: TravelStepKey[];
  // A recorded board decision file counts as sent, even without the mark.
  sentToBoard: boolean | null;
}

export type TravelApprovalParams = PagedParams<TravelApprovalFilter>;

export interface TravelApprovalRow extends TravelRequestSummary {
  overlapCount: number;
  sentToBoardAt?: string | null;
}

export type TravelApprovalQueue = PagedResponse<TravelApprovalRow>;

export interface TravelDecisionRequest {
  reason: string;
}

export const travelBoardOutcomeList = ['approve', 'reject'] as const;
export type TravelBoardOutcome = (typeof travelBoardOutcomeList)[number];

export interface TravelReturnRequest extends TravelDecisionRequest {
  // Null falls back to the admin setting server-side, which is what the dialog sends when it could not read that setting.
  returnMode: TravelReturnMode | null;
  notifyOtherApprovers: boolean;
}

export interface TravelDeanMailRoutingViceDean {
  id: number;
  name: string;
  facultyName: string;
  selected: boolean;
}

export interface TravelDeanMailRouting {
  enabled: boolean;
  viceDeans: TravelDeanMailRoutingViceDean[];
}

export interface TravelDeanMailRoutingRequest {
  enabled: boolean;
  viceDeanIds: number[];
}
